import { GlobalProvider } from '../../../../../utils/globalprovider';
import Dialog from '../../../../dialogs/dialog';
import SpeakerForm from '../speakerform/speakerform';

import React from 'react';
import './commonspeakerform.css';

class CommonSpeakerForm extends Dialog {
  constructor(props) {
    super(props);

    this.state.title = props.title;
    this.state.buttons = [
      {
        type: 'text',
        disabled: false,
        text: { fr: 'Valider', en: 'Submit' },
        key: 'submit',
      },
      { type: 'back', disabled: false },
    ];

    this.state.speaker = props.speaker;

    this.handleButton = this.handleButton.bind(this);
    this.onQuit = this.onQuit.bind(this);
    this.onUpdateSpeaker = this.onUpdateSpeaker.bind(this);

    this.speakerFormRef = React.createRef();
  }

  onQuit() {
    this.props.onButton({ name: 'back' });
  }

  onUpdateSpeaker(speaker) {
    this.setState({ speaker });
  }

  handleButton(buttonkey) {
    switch (buttonkey) {
      case 'back':
        this.onQuit();
        break;

      case 'submit':
         if (!this.state.speaker.name) {
          if (this.speakerFormRef && this.speakerFormRef.current) {
            this.speakerFormRef.current.validateForm();
          }

          return;
        }
        
        this.props.onButton({ name: 'submit', value: this.state.speaker });
        break;

      default:
        return;
    }
  }

  render() {
    var maxheight = (window.innerHeight * 82) / 100;
    if (maxheight > 500) maxheight = 500;

    const retour = (
      <div style={{ height: maxheight }}>
        <div className="divspeakerform">
          <GlobalProvider>
            <SpeakerForm
              ref={this.speakerFormRef}
              speaker={this.props.speaker}
              onUpdateSpeaker={this.onUpdateSpeaker}
            ></SpeakerForm>
          </GlobalProvider>
        </div>
      </div>
    );

    return super.render(retour);
  }
}

export default CommonSpeakerForm;
